"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let ConfirmSyncInvoice = class ConfirmSyncInvoice extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    invoice;
    onInvoice(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice");
    }
    formId;
    onForm_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("formId");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    labelAlign;
    payload;
    async $$load_payload() {
        return {
            id: this.invoice.id,
            print: true,
            print_copies: 1,
            target: "remote",
        };
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['labelAlign', 'payload', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                labelAlign: "right",
                payload: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("ConfirmSyncInvoice.Title", "Create invoice"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_7026_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_4186377094414664_closeModal_7032_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data.response.data,
            },
        };
    }
    async act_4186377094414664_request_7030_getActionArgs($event) {
        return {
            operation: "issue_invoice",
            data: this.payload,
        };
    }
    async evh_4186377094414664_submit(event, scope) {
        return await this.actions.evh_4186377094414664_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_7026 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_7026_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_7025 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_7026,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_7025],
        });
        const act_2248226175642056_closeComponent_7028 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_7027 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_7028,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_7027],
        });
        const act_4186377094414664_closeModal_7032 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_4186377094414664_closeModal_7032_getActionArgs,
            events: [],
        });
        const evh_4186377094414664_success_7031 = new core_1.actions.EventHandlerImpl({
            action: act_4186377094414664_closeModal_7032,
            event: "success",
            displayName: "closeModal",
        });
        const act_4186377094414664_request_7030 = new core_1.actions.RequestAction({
            actionArgs: this.act_4186377094414664_request_7030_getActionArgs,
            displayName: "submit",
            events: [evh_4186377094414664_success_7031],
        });
        const evh_4186377094414664_submit_7029 = new core_1.actions.EventHandlerImpl({
            action: act_4186377094414664_request_7030,
            event: "submit",
            displayName: "submit",
        });
        const evh_4186377094414664_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4186377094414664_submit_7029],
        });
        const act_1419464017721962_closeComponent_7034 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_7033 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_7034,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_7033],
        });
        return {
            act_7315092382398562_closeModal_7026,
            evh_7315092382398562_close_7025,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_7028,
            evh_2248226175642056_close_7027,
            evh_2248226175642056_close,
            act_4186377094414664_closeModal_7032,
            evh_4186377094414664_success_7031,
            act_4186377094414664_request_7030,
            evh_4186377094414664_submit_7029,
            evh_4186377094414664_submit,
            act_1419464017721962_closeComponent_7034,
            evh_1419464017721962_clickPreventStop_7033,
            evh_1419464017721962_clickPreventStop,
            submit: act_4186377094414664_request_7030,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], ConfirmSyncInvoice.prototype, "invoice", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ConfirmSyncInvoice.prototype, "onInvoice", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: function () {
            return this.$fn.randomElementId();
        },
    }),
    __metadata("design:type", String)
], ConfirmSyncInvoice.prototype, "formId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('formId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ConfirmSyncInvoice.prototype, "onForm_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], ConfirmSyncInvoice.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ConfirmSyncInvoice.prototype, "onSize", null);
ConfirmSyncInvoice = __decorate([
    (0, vue_property_decorator_1.Component)()
], ConfirmSyncInvoice);
exports.default = ConfirmSyncInvoice;
vue_property_decorator_1.Vue.component("ConfirmSyncInvoice", ConfirmSyncInvoice);
